import { Query } from 'apollo-angular';
import { Injectable } from '@angular/core';
import gql from 'graphql-tag';

// Model
import { PTM } from '../models/PTM';

@Injectable({
  providedIn: 'root'
})
export class PTMQuery extends Query<PTM, {}> {
  document = gql`
    query ptmQuery($friendlyId: String) {
      pTMs(where: { friendlyId: $friendlyId}) {
        friendlyId
        nombrePublico
        tituloPaginaIntermedia
        versiondigital
        heroDescription
        heroImg {
          url
          alt
        }
        heroRImg {
          url
          alt
        }
        textoBotonHero
        linkBotonHero
        cardTitulo
        categoriaProductos {
          categoria
        }
        tarjetas {
          nombre
          descripcionTarjeta
          imagen {
            url
            alt
          }
          thumbnail {
            url
            alt
          }
        }
        caracteristicas {
          titulo
          descripcion
          icono {
            url
            alt
          }
        }
        beneficios {
          titulo: tituloPublico
          descripcion
          displayIndex
          icono {
            url
            alt
          }
        }
        ventajas {
          titulo
          descripcion
          displayIndex
          icono {
            url
            alt
          }
        }
        tyC {
          url
        }
        metaDescripciones {
          nombreTag
          contenidoTag
          contenidoImagen {
            url
          }
        }
      }
    }
  `;
}
